import { createLoadingReducer } from './utils';

export default createLoadingReducer('AMIDO_SETTINGS');
